import {standardListener} from '../config/vars';
import axios from 'axios';

export default class EditAccountData {

  constructor(el) {

    this.el = el;
    this.eventHandler = this.handler.bind(this);
    this.el.addEventListener(standardListener, this.eventHandler, false);
  }

  handler(e) {
    e.preventDefault();

    const address_id = this.el.getAttribute('data-delete-address');
    const method = window.routes.deleteAddress[1];
    const url = window.routes.deleteAddress[0];

    axios({
      method,
      url,
      data: {
        address_id,
      },
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(() => {
      window.location = window.location.pathname;
    });
  }
}
